export interface ITabOption<T> {
  label: string
  value: T
}

export function tabOptionFromValue<T>(
  value: T,
  labelFormatter: (value: T) => string,
): ITabOption<T> {
  return {
    label: labelFormatter(value),
    value,
  }
}
